

// src/services/agentService.js
import api from './api';

// --- Workspace Functions ---
export const getWorkspaces = async () => {
    const response = await api.get('/api/workspaces');
    return response.data.data;
};

export const createTeamWorkspace = async (name) => {
    const response = await api.post('/api/workspaces/create', { name });
    return response.data.data;
};

export const updateWorkspace = async (workspaceId, data) => {
    const response = await api.put(`/api/workspaces/${workspaceId}/update`, data);
    return response.data;
};

export const getWorkspaceSettings = async (workspaceId) => {
    const response = await api.get(`/api/workspaces/${workspaceId}/settings`);
    return response.data.data;
};

// --- GURU ADDITION: Business Hub Functions ---
export const getWorkspaceBusinessData = async (workspaceId) => {
    const response = await api.get(`/api/workspaces/${workspaceId}/business-data`);
    return response.data.data;
};

export const updateWorkspaceBusinessData = async (workspaceId, data) => {
    const response = await api.put(`/api/workspaces/${workspaceId}/business-data`, data);
    return response.data.data;
};


// --- Agent Template Functions ---
export const getAgentTemplates = async () => {
    try {
        console.log('Fetching agent templates...');
        const response = await api.get('/api/agents/templates');
        console.log('Agent templates response:', response.data);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching agent templates:', error);
        throw error;
    }
};

// --- Workspace Agent Functions ---
export const getWorkspaceAgents = async (workspaceId) => {
    const response = await api.get(`/api/workspaces/${workspaceId}/agents`);
    return response.data.data;
};

export const createWorkspaceAgent = async (payload) => {
    // This function now accepts and sends the entire payload object.
    const response = await api.post('/api/workspaces/agents', payload);
    return response.data.data;
};

export const getAgentDetails = async (workspaceId, agentId) => {
    const response = await api.get(`/api/workspaces/${workspaceId}/agents/${agentId}`);
    return response.data.data;
}

export const updateAgentDetails = async (workspaceId, agentId, data) => {
    const response = await api.put(`/api/workspaces/${workspaceId}/agents/${agentId}`, data);
    return response.data;
}

// --- Agent Interaction Functions ---
export const getChatHistory = async (workspaceId, agentId) => {
    const response = await api.get(`/api/workspaces/${workspaceId}/agents/${agentId}/chat-history`);
    return response.data.data;
};

export const executeAgentTask = async (workspaceId, agentId, prompt, model) => {
    const response = await api.post('/api/ai/execute', { workspaceId, agentId, prompt, model });
    return response.data.data;
};

